<template>
    <div v-if="isLoaded">
        <div class="content-body" v-bind:class="{ fullscreen_expand: isFullscreen }">
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card" style="">
                        <div class="card-header">
                            <v-tour name="blogisticTour" :steps="steps" :callbacks="callbacksTour"></v-tour>
                            <h4 class="card-title">Relatórios</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3" @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"></i></a>
                            <div class="heading-elements"  v-bind:class="{ visible: getSubMenuShowHideFw(), '': !getSubMenuShowHideFw() }">
                                <ul class="list-inline mb-0">
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Expande a tela" v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Minimiza a tela" v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                                    <li><a @click="onFilterShowHide()" v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="table">
                                <div class="box-typical-body">
                                    <div class="container-fluid">
                                        <div class="row loadingDataPosition">
                                            <div class="loadingData" v-if="loading"><div class="loadingDataSpinner"><spinner v-if="loading" text-fg-color="#ffffff" message="Carregando..."></spinner></div></div>
                                            <div class="container-fluid">
                                                <h5>Relatório Gerenciamento de frete</h5>
                                                <b-row no-gutters>
                                                    <b-col>
                                                        <div class="fl-flex-label fl-collapsed fl-background">
                                                            <input type="text" class="form-control" v-model="form1.num_fiscal">
                                                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Nº Fiscal</label>
                                                        </div>
                                                    </b-col>
                                                    <b-col>
                                                        <div class="fl-flex-label fl-collapsed fl-background">
                                                            <input type="text" class="form-control" v-model="form1.chave">
                                                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Chave</label>
                                                        </div>
                                                    </b-col>
                                                    <b-col sm="6" md="2" class="p-0">
                                                        <b-form-datepicker
                                                        locale="pt-br" 
                                                        reset-button
                                                        placeholder="Data Inicio" 
                                                        v-model="form1.dt_ini" 
                                                        class="form-control" 
                                                        :date-format-options="{day: 'numeric', month: 'numeric', year: 'numeric' }"
                                                        @keyup.enter="doFilter">
                                                        </b-form-datepicker>
                                                    </b-col>
                                                    <b-col sm="6" md="2" class="p-0">
                                                        <b-form-datepicker
                                                        locale="pt-br" 
                                                        reset-button
                                                        placeholder="Data Fim" 
                                                        v-model="form1.dt_fim" 
                                                        class="form-control" 
                                                        :date-format-options="{day: 'numeric', month: 'numeric', year: 'numeric' }"
                                                        @keyup.enter="doFilter">
                                                        </b-form-datepicker>
                                                    </b-col>
                                                    <b-btn @click="doGerar(1)" variant="secondary" :disabled="isDisabled">
                                                        Extrair
                                                    </b-btn>
                                                    <b-btn @click="doLimpar(1)" variant="secondary">
                                                        Limpar
                                                    </b-btn>
                                                </b-row>
                                            </div>

                                            <div class="container-fluid mt-2">
                                                <h5>Relatório de Frete por transporte</h5>
                                                <b-row no-gutters>
                                                    <b-col>
                                                        <div class="fl-flex-label fl-collapsed fl-background">
                                                            <input type="text" class="form-control" v-model="form2.num_fiscal">
                                                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Nº Fiscal</label>
                                                        </div>
                                                    </b-col>
                                                    <b-col>
                                                        <div class="fl-flex-label fl-collapsed fl-background">
                                                            <input type="text" class="form-control" v-model="form2.chave">
                                                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Chave</label>
                                                        </div>
                                                    </b-col>
                                                    <b-col sm="6" md="2" class="p-0">
                                                        <b-form-datepicker
                                                        locale="pt-br" 
                                                        reset-button
                                                        placeholder="Data Inicio" 
                                                        v-model="form2.dt_ini" 
                                                        class="form-control" 
                                                        :date-format-options="{day: 'numeric', month: 'numeric', year: 'numeric' }"
                                                        @keyup.enter="doFilter">
                                                        </b-form-datepicker>
                                                    </b-col>
                                                    <b-col sm="6" md="2" class="p-0">
                                                        <b-form-datepicker
                                                        locale="pt-br"
                                                        reset-button 
                                                        placeholder="Data Fim" 
                                                        v-model="form2.dt_fim" 
                                                        class="form-control" 
                                                        :date-format-options="{day: 'numeric', month: 'numeric', year: 'numeric' }"
                                                        @keyup.enter="doFilter">
                                                        </b-form-datepicker>
                                                    </b-col>
                                                    <b-btn @click="doGerar(2)" variant="secondary" :disabled="isDisabled">
                                                        Extrair
                                                    </b-btn>
                                                    <b-btn @click="doLimpar(2)" variant="secondary">
                                                        Limpar
                                                    </b-btn>
                                                </b-row>
                                            </div>

                                            <div class="container-fluid mt-2">
                                                <h5>Relatório de Faturas</h5>
                                                <b-row no-gutters>
                                                    <b-col>
                                                        <div class="fl-flex-label fl-collapsed fl-background">
                                                            <input type="text" class="form-control" v-model="form3.num_fiscal">
                                                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Nº Fiscal</label>
                                                        </div>
                                                    </b-col>
                                                    <b-col>
                                                        <div class="fl-flex-label fl-collapsed fl-background">
                                                            <input type="text" class="form-control" v-model="form3.chave">
                                                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Chave</label>
                                                        </div>
                                                    </b-col>
                                                    <b-col sm="6" md="2" class="p-0">
                                                        <b-form-datepicker
                                                        locale="pt-br" 
                                                        reset-button
                                                        placeholder="Data Inicio" 
                                                        v-model="form3.dt_ini" 
                                                        class="form-control" 
                                                        :date-format-options="{day: 'numeric', month: 'numeric', year: 'numeric' }"
                                                        @keyup.enter="doFilter">
                                                        </b-form-datepicker>
                                                    </b-col>
                                                    <b-col sm="6" md="2" class="p-0">
                                                        <b-form-datepicker
                                                        locale="pt-br" 
                                                        reset-button
                                                        placeholder="Data Fim" 
                                                        v-model="form3.dt_fim" 
                                                        class="form-control" 
                                                        :date-format-options="{day: 'numeric', month: 'numeric', year: 'numeric' }"
                                                        @keyup.enter="doFilter">
                                                        </b-form-datepicker>
                                                    </b-col>
                                                    <b-btn @click="doGerar(3)" variant="secondary" :disabled="isDisabled">
                                                        Extrair
                                                    </b-btn>
                                                    <b-btn @click="doLimpar(3)" variant="secondary">
                                                        Limpar
                                                    </b-btn>
                                                </b-row>
                                            </div>

                                            <div class="container-fluid mt-2">
                                                <h5>Relatório de Pré-fatura despesa</h5>
                                                <b-row no-gutters>
                                                    <b-col>
                                                        <div class="fl-flex-label fl-collapsed fl-background">
                                                            <input type="text" class="form-control" v-model="form4.num_fiscal">
                                                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Nº Fiscal</label>
                                                        </div>
                                                    </b-col>
                                                    <b-col>
                                                        <div class="fl-flex-label fl-collapsed fl-background">
                                                            <input type="text" class="form-control" v-model="form4.chave">
                                                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Chave</label>
                                                        </div>
                                                    </b-col>
                                                    <b-col sm="6" md="2" class="p-0">
                                                        <b-form-datepicker
                                                        locale="pt-br"
                                                        reset-button 
                                                        placeholder="Data Inicio" 
                                                        v-model="form4.dt_ini" 
                                                        class="form-control" 
                                                        :date-format-options="{day: 'numeric', month: 'numeric', year: 'numeric' }"
                                                        @keyup.enter="doFilter">
                                                        </b-form-datepicker>
                                                    </b-col>
                                                    <b-col sm="6" md="2" class="p-0">
                                                        <b-form-datepicker
                                                        locale="pt-br" 
                                                        reset-button
                                                        placeholder="Data Fim" 
                                                        v-model="form4.dt_fim" 
                                                        class="form-control" 
                                                        :date-format-options="{day: 'numeric', month: 'numeric', year: 'numeric' }"
                                                        @keyup.enter="doFilter">
                                                        </b-form-datepicker>
                                                    </b-col>
                                                    <b-btn @click="doGerar(4)" variant="secondary" :disabled="isDisabled">
                                                        Extrair
                                                    </b-btn>
                                                    <b-btn @click="doLimpar(4)" variant="secondary">
                                                        Limpar
                                                    </b-btn>
                                                </b-row>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { formatCNPJFromParts } from "../utils";

import moment from 'moment'
import accounting from 'accounting'

export default {
    data () {
        return {
            date_attributes: [{key: 'today',highlight: true,dates: new Date()}],
            loading: false,
            isDisabled: false,
            loadingData: false,
            isFullscreen: false,
            showModal: false,
            transportadora: [],
            optionsTransportadora: [],
            helpForm: new Form({statusRecord: [], params: [], search: "",}),
            isLoadingTransportadora: false,
          form1: new Form({
              num_fiscal: '',
              chave: '',
              dt_ini: '',
              dt_fim: '',
              cd_relatorio: 1
           }),
           form2: new Form({
               num_fiscal: '',
               chave: '',
               dt_ini: '',
               dt_fim: '',
               cd_relatorio: 2
            }),
            form3: new Form({
                num_fiscal: '',
                chave: '',
                dt_ini: '',
                dt_fim: '',
                cd_relatorio: 3
             }),
            form4: new Form({
                 num_fiscal: '',
                 chave: '',
                 dt_ini: '',
                 dt_fim: '',
                 cd_relatorio: 4
             }),
       }
    },
    methods: {
        doGerar(cd_relatorio) {
            this.loading = true;
            this.isDisabled = true;
            if(cd_relatorio==1)
            {
                this.form1.cd_relatorio = cd_relatorio;
                this.form1.dt_ini = this.formatDateSubmit(this.form1.dt_ini);
                this.form1.dt_fim = this.formatDateSubmit(this.form1.dt_fim);
                this.form1.post('/api/relatorio/gerar').then(response =>
                {
                    new ReturnApi(response, this)
                })
                .catch(errors =>
                {
                    new ReturnApi(errors, this)
                });
            }
            else if(cd_relatorio==2)
            {
                this.form2.cd_relatorio = cd_relatorio;
                this.form2.dt_ini = this.formatDateSubmit(this.form2.dt_ini);
                this.form2.dt_fim = this.formatDateSubmit(this.form2.dt_fim);
                this.form2.post('/api/relatorio/gerar').then(response =>
                {
                    new ReturnApi(response, this)
                })
                .catch(errors =>
                {
                    new ReturnApi(errors, this)
                });
            }
            else if(cd_relatorio==3)
            {
                this.form3.cd_relatorio = cd_relatorio;
                this.form3.dt_ini = this.formatDateSubmit(this.form3.dt_ini);
                this.form3.dt_fim = this.formatDateSubmit(this.form3.dt_fim);
                this.form3.post('/api/relatorio/gerar').then(response =>
                {
                    new ReturnApi(response, this)
                })
                .catch(errors =>
                {
                    new ReturnApi(errors, this)
                });
            }
            else if(cd_relatorio==4)
            {
                this.form4.cd_relatorio = cd_relatorio;
                this.form4.dt_ini = this.formatDateSubmit(this.form4.dt_ini);
                this.form4.dt_fim = this.formatDateSubmit(this.form4.dt_fim);
                this.form4.post('/api/relatorio/gerar').then(response =>
                {
                    new ReturnApi(response, this)
                })
                .catch(errors =>
                {
                    new ReturnApi(errors, this)
                });
            }
        },
        doLimpar(cd_relatorio)
        {
            if(cd_relatorio==1)
            {
                this.form1.num_fiscal = '';
                this.form1.chave = '';
                this.form1.dt_inicio = '';
                this.form1.dt_fim = '';
            }
            if(cd_relatorio==2)
            {
                this.form2.num_fiscal = '';
                this.form2.chave = '';
                this.form2.dt_inicio = '';
                this.form2.dt_fim = '';
            }
            if(cd_relatorio==3)
            {
                this.form3.num_cliente = '';
                this.form3.chave = '';
                this.form3.dt_inicio = '';
                this.form3.dt_fim = '';
            }
            if(cd_relatorio==4)
            {
                this.form4.num_cliente = '';
                this.form4.chave = '';
                this.form4.dt_inicio = '';
                this.form4.dt_fim = '';
            }
        },
              listaTransportadora(search) {
        if (search.length >= 3) {
            this.isLoadingTransportadora = true;
            this.helpForm.search = search;
            this.helpForm.status = 1;
            this.helpForm
            .post("/api/pessoa/jsonlist/transportadora")
            .then((response) => {
                this.optionsTransportadora = [];
                new ReturnApi(response, this, true, false, false);
                if (response.items.length > 0) {
                response.items.forEach((obj) => {
                    this.optionsTransportadora.push({
                    label: "PJ -" + obj.pessoa.cd + " - " + obj.razao_social + " - " + this.onFormataCnpj( obj.cnpj_base, obj.cnpj_filial, obj.cnpj_digito).replace(/([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/, "$1.$2.$3/$4-$5") + " - " + obj.inscricao_estadual, pessoa_id: obj.pessoa_id, value: obj.pessoa_id,
                    });
                });
                }
                if (response.itemsF.length > 0) {
                response.itemsF.forEach((obj) => {
                    this.optionsTransportadora.push({
                    label: "PF -" + obj.nome + " - " + obj.cpf,
                    pessoa_id: obj.pessoa_id,
                    value: obj.pessoa_id,
                    });
                });
                }
                if (response.itemsE.length > 0) {
                response.itemsE.forEach((obj) => {
                    this.optionsTransportadora.push({
                    label: "PE -" + obj.nome + " - " + obj.cd,
                    pessoa_id: obj.pessoa_id,
                    value: obj.pessoa_id,
                    });
                });
                }
                this.isLoadingTransportadora = false;
            })
            .catch((errors) => {
                new ReturnApi(errors, this);
            });
        }
    },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
        formatDateSubmit (value, fmt = 'DD/MM/YYYY') {
          return (value == null || value == "")
            ? ''
            : moment(value, 'YYYY/MM/DD HH:mm').format(fmt)
        },
        expandFullscreen() {
            this.isFullscreen = !this.isFullscreen;
        },
    },
    computed: {
        vuetableFilterRow: {
            get () {
                return this.$store.getters.vuetable.filterRow;
            },
        },
        isLoaded: {
            get() {
                return this.$store.getters.isloaded;
            }
        }
    }
}
</script>